import HeroHeading from '../Headings/HeroHeading'
import HeroTopHeading from '../Headings/HeroTopHeading'
import HeroDescription from '../Headings/HeroDescription'
import BookACallButton from '../Buttons/Specials/BookACallButton'

function HeroSection() {
    return (
        <div className="md:pt-20 pb-10 md:pb-32 md:-mt-20 -mt-12 pt-12 relative border-solid border-t-2">
            <div className="m-auto max-w-full w-[1300px] px-4 xl:px-6 relative flex flex-col md:flex-row items-center md:items-center">
                <div className="w-full md:w-7/12">
                    <div className="md:text-left text-center">
                        <HeroTopHeading>Open Letter Marketing</HeroTopHeading>
                        <div className="m-auto text-center md:text-left">
                            <HeroHeading>
                                High-Impact Real Estate Postcards That Get
                                Sellers Calling You Back
                            </HeroHeading>
                        </div>

                        <div className="max-w-full bg-cover bg-no-repeat relative md:static md:w-10/12 md:space-y-10 md:pt-4">
                            <div className="hidden md:block">
                                <HeroDescription>
                                    Maximize your deal flow with postcards
                                    designed specifically for real estate
                                    investors and agents. Not all postcards are
                                    created equal. At Open Letter Marketing, we
                                    create precision-targeted postcards that
                                    deliver higher response rates, faster
                                    turnaround, and better ROI than generic mail
                                    houses.
                                </HeroDescription>
                            </div>

                            <div className="md:hidden">
                                <img
                                    src="/assets/real-estate-postcards/cards.webp"
                                    alt="Floating Postcard design for real estate investors"
                                    title="Unique postcard design with standout results"
                                    className=" m-auto"
                                />
                            </div>

                            <div className="md:hidden mb-6 text-center">
                                <HeroDescription>
                                    Maximize your deal flow with postcards
                                    designed specifically for real estate
                                    investors and agents. Not all postcards are
                                    created equal. At Open Letter Marketing, we
                                    create precision-targeted postcards that
                                    deliver higher response rates, faster
                                    turnaround, and better ROI than generic mail
                                    houses.
                                </HeroDescription>
                            </div>

                            <div className="grid relative md:pt-[0px] grid-flow-row md:grid-flow-col md:grid-cols-1 gap-4 max-w-sm">
                                <div className="">
                                    <BookACallButton>
                                        Order Real Estate Postcards Now
                                    </BookACallButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="hidden md:flex w-full md:w-5/12 justify-center md:justify-end">
                    <img
                        src="/assets/real-estate-postcards/cards.webp"
                        alt="Floating Postcard design for real estate investors"
                        title="Unique postcard design with standout results"
                        className=""
                    />
                </div>
            </div>
        </div>
    )
}

export default HeroSection
